import { JSONUtilites } from '../../../helpers/JSONUtilites';

export class ProductPricelistItem {
  id: number;
  name: string;
  categId: number;
  minQuantity: number;
  priceDiscount: number;
  priceMaxMargin: number;
  priceMinMargin: number;
  priceRound: number;
  priceSurcharge: number;
  productId: number;
  productTmplId: number;
  sequence: number;

  constructor() { }

  static arrayFromJSON(json: string): ProductPricelistItem[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: ProductPricelistItem[] = [];
    for (const item of values) {
      result.push(ProductPricelistItem.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): ProductPricelistItem {
    if (object === null || object === undefined) {
      return null;
    }
    const productPricelistItem = new ProductPricelistItem();
    productPricelistItem.id = object.id;
    productPricelistItem.name = object.name;
    productPricelistItem.categId = object.categId;
    productPricelistItem.minQuantity = object.minQuantity;
    productPricelistItem.priceDiscount = object.priceDiscount;
    productPricelistItem.priceMaxMargin = object.priceMaxMargin;
    productPricelistItem.priceMinMargin = object.priceMinMargin;
    productPricelistItem.priceRound = object.priceRound;
    productPricelistItem.priceSurcharge = object.priceSurcharge;
    productPricelistItem.productId = object.productId;
    productPricelistItem.productTmplId = object.productTmplId;
    productPricelistItem.sequence = object.sequence;
    return productPricelistItem;
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      categId: this.categId,
      minQuantity: this.minQuantity,
      priceDiscount: this.priceDiscount,
      priceMaxMargin: this.priceMaxMargin,
      priceMinMargin: this.priceMinMargin,
      priceRound: this.priceRound,
      priceSurcharge: this.priceSurcharge,
      productId: this.productId,
      productTmplId: this.productTmplId,
      sequence: this.sequence,
    };
  }
}
